module.exports = __webpack_public_path__ + "static/media/cover13.de8c0370.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover13.png
// module id = 566
// module chunks = 0